module.exports = __webpack_public_path__ + "img/signin-bg.b0f400fd.jpg";